import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Theme } from '@mui/material/styles';
import { Stack, Typography } from '@monorepo/nova-ui';
import { TradingPlatformsButtons } from '@monorepo/react-components';
import { TradingSystem } from '@monorepo/types';
import { BannerTextContainer } from '../styled';
import { getButtonStyles, getResponsiveTypographyStyles } from './styles';

interface PlatformSectionProps {
  tradingSystem: TradingSystem;
}

export const PlatformSection: FC<PlatformSectionProps> = ({
  tradingSystem,
}) => {
  const { t } = useTranslation('thankYou');

  return (
    <BannerTextContainer>
      <Stack gap={4}>
        <Typography
          variant="subtitle1"
          sx={(theme) => getResponsiveTypographyStyles(theme).description}
        >
          {t('platform_download_description')}
        </Typography>

        <TradingPlatformsButtons
          tradingSystem={tradingSystem}
          buttonSx={(theme: Theme) => getButtonStyles(theme).platformButton}
          gap={4}
        />
      </Stack>
    </BannerTextContainer>
  );
};
